import { Component, ElementRef, QueryList, Renderer2, ViewChildren } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';

@Component({
  selector: 'app-sch-guidelines',
  templateUrl: './sch-guidelines.component.html',
  styleUrls: ['./sch-guidelines.component.scss']
})
export class SchGuidelinesComponent {

  
}
